var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('i',{staticClass:"fas fa-search text-orange-500 text-2xl"}),_vm._v(" "),_c('h3',{staticClass:"mt-2 text-lg font-medium text-gray-900"},[_vm._v("\n    "+_vm._s(_vm.$tc('products_title', 0))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }